"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideCheckbox = void 0;
var React = __importStar(require("react"));
exports.GuideCheckbox = function (props) {
    return React.createElement("a", { onClick: props.onClick }, props.checked ?
        React.createElement("span", { "aria-label": "Klicka f\u00F6r att kryssa ur", className: "check checked", "data-balloon-pos": "up" },
            React.createElement("i", { className: "fas fa-check" }))
        :
            React.createElement("span", { "aria-label": "Klicka f\u00F6r att kryssa i", className: "check uncheck", "data-balloon-pos": "up" },
                React.createElement("i", { className: "fas fa-check" })));
};
// rails-react needs a default export in order to be able to find a component
// noinspection JSUnusedGlobalSymbols
exports.default = exports.GuideCheckbox;
